import { IOffice } from "@cai-services";

export class OfficeUtil {
  static getOfficeName (office: IOffice): string {
    if(!office){
      return;
    }
    if (office.name?.length > 0) {
      return office.name;
    }

    return OfficeUtil.getLongOfficeName(office);
  }

  static getLongOfficeName (office: IOffice): string {
    const longOfficeNameWithoutIataCass = `${office.country?.countryCode}--${(office.airports&&office.airports.length>0)?(office.airports[0].airportCode):""}`;

    if (!office.iata || !office.cass) {
      return longOfficeNameWithoutIataCass;
    }

    return `${longOfficeNameWithoutIataCass}-${office.iata}-${office.cass}`;
  }

  static sortCompare (
    a: number | string | boolean,
    b: number | string | boolean,
    isAsc: boolean,
  ) {
    if ((a === undefined || a === null) && (b === undefined || b === null)) {
      return 0;
    }
    if (a === undefined || a === null) {
      return -1 * (isAsc ? 1 : -1);
    }
    if (b === undefined || b === null) {
      return 1 * (isAsc ? 1 : -1);
    }
    if (a == b) {
      return 0;
    }
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  static sortCompare2 (
    a1: number | string | boolean,
    b1: number | string | boolean,
    isAsc1: boolean,
    a2: number | string | boolean,
    b2: number | string | boolean,
    isAsc2: boolean,
  ) {
    const result = this.sortCompare(a1, b1, isAsc1);
    if (result == 0) {
      return this.sortCompare(a2, b2, isAsc2);
    } else {
      return result;
    }
  }
}
